module.exports = __webpack_public_path__ + "static/media/metadsp.32c655ba.png";